import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import DropdownMenu from 'react-dd-menu';
import { Link, withRouter } from 'react-router-dom';
import { PROFILE_PATH, DOMAIN_PATH } from 'routes';

import manIcon from 'images/man-icon.svg';
import planIcon from 'images/plan-icon.svg';
import logOutIcon from 'images/log-out-icon.svg';

import copy from 'copy-to-clipboard';
import AlertMessage from 'components/AlertMessage';
import copyIcon from 'images/copy.svg';

class AccountMenu extends React.Component {
  state = {
    isMenuOpen: false,
    showAlert: false,
  };

  handleCopy = e => {
    e.preventDefault();
    const text = this.refs['ref-link'].value;
    copy(text);
    this.toggleAlert();
    setTimeout(() => this.toggleAlert(), 4000);
  };

  toggleAlert = () => {
    this.setState({ showAlert: !this.state.showAlert });
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    const { isMenuOpen, showAlert } = this.state;
    const { aff_dashboard_url, aff_referral_url } = this.props.details;

    return (
      <Fragment>
        {showAlert && <AlertMessage text="Your link copied to clipboard!" />}
        <Link to={DOMAIN_PATH} className="drop-menu__link">
          My Domains
        </Link>
        <a href={aff_dashboard_url} className="drop-menu__link" target="_blank">
          Affiliate dashboard
        </a>
        <DropdownMenu
          isOpen={isMenuOpen}
          close={this.close}
          toggle={
            <button
              className="account-link text"
              type="button"
              onClick={this.toggle}>
              My account
            </button>
          }
          align="right">
          <li className="drop-menu__itm">
            <Link to={PROFILE_PATH} className="drop-menu__link">
              My profile
            </Link>
          </li>
          <li
            className="drop-menu__itm"
            style={{
              borderTop: '1px solid #E1E6EC',
              borderBottom: '1px solid #E1E6EC',
            }}>
            <div
              style={{
                position: 'relative',
                flex: '1 1 auto',
              }}>
              <div
                onClick={this.handleCopy}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '20px',
                  cursor: 'pointer',
                }}>
                <img src={copyIcon} alt="copy to clipboard" />
              </div>
              <input
                ref="ref-link"
                type="text"
                value={aff_referral_url}
                className="form-input input-border form-control"
                style={{
                  paddingRight: '35px',
                }}
              />
            </div>
          </li>
          <li className="drop-menu__itm" style={{ position: 'relative' }}>
            <Link
              to="/"
              className="drop-menu__link"
              onClick={this.props.navigateTo}>
              Log out
            </Link>
            <div style={{ position: 'absolute', right: '20px' }}>
              <img src={logOutIcon} alt="" />
            </div>
          </li>
        </DropdownMenu>
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
  };
}

export default connect(mapStateProps)(AccountMenu);



// WEBPACK FOOTER //
// ./src/scenes/Header/account-menu.js